import { render, staticRenderFns } from "./purchaseDiscounts.vue?vue&type=template&id=04e45742"
import script from "./purchaseDiscounts.vue?vue&type=script&lang=js"
export * from "./purchaseDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports